<h2 mat-dialog-title>{{ 'AI_ASSISTANT.ASSISTANT_REFERENCE_CARD.SELECT_ASSISTANT' | translate }}</h2>
<mat-dialog-content>
  @if (assistantResource.isLoading()) {
    <div class="loading-container">
      <glxy-loading-spinner
        [size]="'default'"
        [fullWidth]="true"
        [fullHeight]="false"
        [inline]="false"
      ></glxy-loading-spinner>
    </div>
  }
  @if (listingFailed()) {
    <glxy-alert type="error">
      {{ 'AI_ASSISTANT.WORKFORCE.ERRORS.LOAD_FAILED' | translate }}
    </glxy-alert>
  }
  @if (hasNoOfferableAssistants()) {
    <glxy-empty-state [size]="'small'">
      <glxy-empty-state-hero>
        <mat-icon>smart_toy</mat-icon>
      </glxy-empty-state-hero>
      <glxy-empty-state-title>
        {{ 'AI_ASSISTANT.ASSISTANT_REFERENCE_CARD.EMPTY_STATE.HEADLINE' | translate }}
      </glxy-empty-state-title>
      <p>{{ 'AI_ASSISTANT.ASSISTANT_REFERENCE_CARD.EMPTY_STATE.DESCRIPTION' | translate }}</p>
      <glxy-empty-state-actions>
        <button mat-stroked-button (click)="navigateToAIWorkforce()">
          {{ 'AI_ASSISTANT.ASSISTANT_REFERENCE_CARD.EMPTY_STATE.ACTION' | translate }}
        </button>
      </glxy-empty-state-actions>
    </glxy-empty-state>
  }
  @for (assistant of assistants(); track assistant.assistant.id) {
    @let active = selectedAssistant() === assistant;
    <div class="assistant-row" [ngClass]="{ active: active }" (click)="selectAssistant(assistant)">
      <div>
        @if (getAvatarSrc(assistant); as avatarSrc) {
          <glxy-avatar [src]="avatarSrc" [name]="assistant.assistant.name"></glxy-avatar>
        } @else {
          <glxy-avatar [svgIcon]="defaultAvatarIcon" [name]="assistant.assistant.name"></glxy-avatar>
        }
      </div>
      <div class="assistant-info">
        <div class="name">
          {{ assistant.assistant.name }}
        </div>
        @if (assistant.descriptionKey) {
          <div>
            {{ assistant.descriptionKey | translate }}
          </div>
        }
      </div>
      @if (active) {
        <div class="active-indicator">
          <mat-icon fontIcon="check_circle"></mat-icon>
        </div>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>{{ 'AI_ASSISTANT.SHARED.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" [mat-dialog-close]="selectedAssistant()" cdkFocusInitial>
    {{ 'AI_ASSISTANT.SHARED.OK' | translate }}
  </button>
</mat-dialog-actions>
